module.exports = __webpack_public_path__ + "img/linepay.1c0ef4ba.png";